import {gql} from 'apollo-boost'

export const SIGNUP_USER = gql`
    mutation($name: String!, $email: String!, $password: String!) {
        signup(data: { name: $name, email: $email, password: $password }) {
            token
            user {
                name
                email
                role
                password
            }
        }
    }
    `
export const SIGNIN_USER = gql`
    mutation($email: String!, $password: String!) {
        signin(data: { email: $email, password: $password }) {
            token
            user {
                role
                email
                password
            }
        }
    }
    `

export const GET_CURRENT_USER = gql`
    query {
        me {
            id
            name
            role
            email
            age
            avatar
        }
    }
    `

export const GET_USERS = gql`
    query {
        users {
            id
            name
            role
            email
        }
    }
    `
export const UPDATE_USER = gql`
mutation($id: ID! $name: String!) {
    updateUser(id: $id name: $name) {
        id
        name
    }
}
`

export const MAKE_ADMINORUSER = gql`
mutation($id: ID! $role: String!) {
    updateUser(id: $id, data: {role: $role}) {
        id
        role
    }
}
`

export const DELETE_USER = gql`
mutation($id: ID!) {
    deleteUser(id: $id) {
        id
        name
    }
}
`